<template>
  <div style="background-color: black">
    <div v-if="showCarousel">
      <div
        class="carousel slide mt-5"
        data-ride="carousel"
        v-for="(currentSize, index) of banners" v-bind:key="currentSize.id"
        v-bind:class="'carousel-inner '+ isMinimumSize(index) +' d-' + currentSize.size + '-block ' + previousSize(index)"
        v-bind:id="currentSize.description"
      >
        <div>
          <div class="carousel-item" data-interval="5000" v-for="(banner, index) of currentSize.files" :class="{ active: index == 0 }" v-bind:key="banner.id">
            <!-- Banners Desktop -->
            <div v-if="banner.status_id == 1">
              <div
                v-if="index == 0"
                @click="irRedirection(banner.redirection)"
                v-bind:style="url(banner.url)"
                class="dinamic-banner"
                title="Bienvenido a Havoline MotoClub"
                :alt="banner.description"
              >
                <h1
                  class="title-home-banner my-2"
                  :style="{ textAlign: `${banner.title_align}` }"
                >
                  {{ banner.description != 'null' ? banner.description : '' }}
                </h1>
                <h2
                  class="subtitle-home-banner"
                  :style="{ textAlign: `${banner.subtitle_align}` }"
                >
                  {{ banner.subtitle != 'null' ? banner.subtitle : '' }}
                  <br>
                </h2>
                <div class="buttons_banners">
                  <!-- Botón 1 -->
                  <button
                    v-if="banner.button_1 != 'null' ? banner.button_1 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_1}` }"
                    @click="irRedirection(banner.redirection_button_1)"
                    class="button_1"
                  >
                    {{ banner.button_1 != 'null' ? banner.button_1 : '' }}
                  </button>
                  <!-- Botón 2 -->
                  <button
                    v-if="banner.button_2 != 'null' ? banner.button_2 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_2}` }"
                    @click="irRedirection(banner.redirection_button_2)"
                    class="button_2"
                  >
                    {{ banner.button_2 != 'null' ? banner.button_2 : '' }}
                  </button>
                </div>
              </div>
              <div
                v-else-if="index == 1"
                @click="irRedirection(banner.redirection)"
                v-bind:style="url(banner.url)"
                class="dinamic-banner"
                title="Beneficios moto club havoline"
                :alt="banner.description"
              >
                <h1
                  class="title-home-banner my-2"
                  :style="{ textAlign: `${banner.title_align}` }"
                >
                  {{ banner.description != 'null' ? banner.description : '' }}
                </h1>
                <h2
                  class="subtitle-home-banner"
                  :style="{ textAlign: `${banner.subtitle_align}` }"
                >
                  {{ banner.subtitle != 'null' ? banner.subtitle : '' }}
                  <br>
                </h2>
                <div class="buttons_banners">
                  <!-- Botón 1 -->
                  <button
                    v-if="banner.button_1 != 'null' ? banner.button_1 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_1}` }"
                    @click="irRedirection(banner.redirection_button_1)"
                    class="button_1"
                  >
                    {{ banner.button_1 != 'null' ? banner.button_1 : '' }}
                  </button>
                  <!-- Botón 2 -->
                  <button
                    v-if="banner.button_2 != 'null' ? banner.button_2 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_2}` }"
                    @click="irRedirection(banner.redirection_button_2)"
                    class="button_2"
                  >
                    {{ banner.button_2 != 'null' ? banner.button_2 : '' }}
                  </button>
                </div>
              </div>
              <div
                v-else-if="index == 2"
                @click="irRedirection(banner.redirection)"
                v-bind:style="url(banner.url)"
                class="dinamic-banner"
                title="Gana puntos havoline moto club"
                :alt="banner.description"
              >
                <h1
                  class="title-home-banner my-2"
                  :style="{ textAlign: `${banner.title_align}` }"
                >
                  {{ banner.description != 'null' ? banner.description : '' }}
                </h1>
                <h2
                  class="subtitle-home-banner"
                  :style="{ textAlign: `${banner.subtitle_align}` }"
                >
                  {{ banner.subtitle != 'null' ? banner.subtitle : '' }}
                  <br>
                </h2>
                <div class="buttons_banners">
                  <!-- Botón 1 -->
                  <button
                    v-if="banner.button_1 != 'null' ? banner.button_1 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_1}` }"
                    @click="irRedirection(banner.redirection_button_1)"
                    class="button_1"
                  >
                    {{ banner.button_1 != 'null' ? banner.button_1 : '' }}
                  </button>
                  <!-- Botón 2 -->
                  <button
                    v-if="banner.button_2 != 'null' ? banner.button_2 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_2}` }"
                    @click="irRedirection(banner.redirection_button_2)"
                    class="button_2"
                  >
                    {{ banner.button_2 != 'null' ? banner.button_2 : '' }}
                  </button>
                </div>
              </div>
              <div
                v-else-if="index == 3"
                @click="irRedirection(banner.redirection)"
                v-bind:style="url(banner.url)"
                class="dinamic-banner"
                title="Puntos Havoline MotoClub"
                :alt="banner.description"
              >
                <h1
                  class="title-home-banner my-2"
                  :style="{ textAlign: `${banner.title_align}` }"
                >
                  {{ banner.description != 'null' ? banner.description : '' }}
                </h1>
                <h2
                  class="subtitle-home-banner"
                  :style="{ textAlign: `${banner.subtitle_align}` }"
                >
                  {{ banner.subtitle != 'null' ? banner.subtitle : '' }}
                  <br>
                </h2>
                <div class="buttons_banners">
                  <!-- Botón 1 -->
                  <button
                    v-if="banner.button_1 != 'null' ? banner.button_1 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_1}` }"
                    @click="irRedirection(banner.redirection_button_1)"
                    class="button_1"
                  >
                    {{ banner.button_1 != 'null' ? banner.button_1 : '' }}
                  </button>
                  <!-- Botón 2 -->
                  <button
                    v-if="banner.button_2 != 'null' ? banner.button_2 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_2}` }"
                    @click="irRedirection(banner.redirection_button_2)"
                    class="button_2"
                  >
                    {{ banner.button_2 != 'null' ? banner.button_2 : '' }}
                  </button>
                </div>
              </div>
              <div
                v-else
                @click="irRedirection(banner.redirection)"
                v-bind:style="url(banner.url)"
                class="dinamic-banner"
                :title="banner.description != 'null' ? banner.description : ''"
                :alt="banner.description"
              >
                <h1
                  class="title-home-banner my-2"
                  :style="{ textAlign: `${banner.title_align}` }"
                >
                  {{ banner.description != 'null' ? banner.description : '' }}
                </h1>
                <h2
                  class="subtitle-home-banner"
                  :style="{ textAlign: `${banner.subtitle_align}` }"
                >
                  {{ banner.subtitle != 'null' ? banner.subtitle : '' }}
                  <br>
                </h2>
                <div class="buttons_banners">
                  <!-- Botón 1 -->
                  <button
                    v-if="banner.button_1 != 'null' ? banner.button_1 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_1}` }"
                    @click="irRedirection(banner.redirection_button_1)"
                    class="button_1"
                  >
                    {{ banner.button_1 != 'null' ? banner.button_1 : '' }}
                  </button>
                  <!-- Botón 2 -->
                  <button
                    v-if="banner.button_2 != 'null' ? banner.button_2 : ''"
                    :style="{ textAlign: `${banner.Alignbutton_2}` }"
                    @click="irRedirection(banner.redirection_button_2)"
                    class="button_2"
                  >
                    {{ banner.button_2 != 'null' ? banner.button_2 : '' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a
          class="carousel-control-prev"
          v-bind:href="'#'+currentSize.description"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          v-bind:href="'#'+currentSize.description"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>

    <div v-if="showLogin && section != 1" class="content-home-class1" id="content-home1" title="Casco fondo havoline moto club" alt="Casco fondo havoline moto club">
      <div
        class="row pb-5 pt-5 justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center  pblr"
      >
        <div class="col-12 col-md-5 col-lg-6 col-xl-6 col-sm-6 mx-auto padding-content2">
          <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div id="accordion">
              <!-- BIENVENIDO AL CLUB QUE TE CUBRE! -->
              <div class="card card-info-home">
                <div class="card-header" id="headingOne">
                  <button data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    <h2 class="movemos">
                      ¡BIENVENIDO AL CLUB QUE TE CUBRE!
                    </h2>
                    <span class="fa-solid fa-caret-down"></span>
                  </button>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                  <div class="card-body">
                    <p class="p-text1">
                      Somos tu destino principal para productos especializados para motociclistas y mecánicos. 
                      Desde herramientas de calidad hasta accesorios indispensables, todo está diseñado para mejorar 
                      tu experiencia en carretera y taller.
                    </p>
                  </div>
                </div>
              </div>

              <!-- CÓMO ACUMULAR PUNTOS -->
              <div class="card card-info-home">
                <div class="card-header" id="headingTwo">
                  <button data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    <h2 class="movemos">
                      ¿CÓMO ACUMULAR PUNTOS?
                    </h2>
                    <span class="fa-solid fa-caret-down"></span>
                  </button>
                </div>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                  <div class="card-body">
                    <p class="p-text1">
                      Obtén puntos fácilmente al ingresar los códigos encontrados en las etiquetas de nuestros 
                      lubricantes para motos. Cada compra te acerca más a recompensas exclusivas y productos 
                      de alta calidad para tí y tu moto.
                    </p>
                  </div>
                </div>
              </div>

              <!-- NUESTRAS RECOMPENSAS -->
              <div class="card card-info-home">
                <div class="card-header" id="headingThree">
                  <button data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseTwo">
                    <h2 class="movemos">
                      NUESTRAS RECOMPENSAS
                    </h2>
                    <span class="fa-solid fa-caret-down"></span>
                  </button>
                </div>
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                  <div class="card-body">
                    <p class="p-text1">
                      <strong>Herramientas para Mecánicos:</strong> Descubre nuestra amplia gama de herramientas duraderas y precisas, 
                      ideales para cualquier tarea de mantenimiento o reparación en tu motocicleta.
                      <br>
                      <strong>Indumentaria y Equipamiento:</strong> Chaquetas, guantes y gorras diseñadas para brindarte confort 
                      y seguridad mientras conduces. ¡No sacrifiques el estilo por la seguridad!
                      <br>
                      <strong>Accesorios Útiles:</strong> Soportes para celular que te mantienen conectado y seguros mientras viajas, 
                      disponibles en varios diseños para adaptarse a tu estilo de manejo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-7 col-lg-6 col-xl-6 col-sm-6 mx-auto ">
          <template>
            <div
              class="row  justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center  pblr"
            >
              <div
                class="col-12 col-md-12 col-lg-7 col-xl-7 col-sm-12 mx-auto padding-content1 padding-content3"
              >
                <p>Únete al club que te cubre en todo momento</p>
              </div>
              <div class="col-12 col-md-12 col-lg-7 col-xl-7 col-sm-12 mx-auto">
                <button
                  type="button"
                  @click="irRegistrar()"
                  class="btn btn-danger btn-md btn-block button-register"
                >
                  <strong>REGÍSTRATE</strong>
                </button>
              </div>
              <div class="col-12 col-md-12 col-lg-7 col-xl-7 col-sm-12 mx-auto">
                <p>
                  Si ya eres parte del club, inicia sesión y registra tus códigos
                </p>
              </div>
              <div class="col-12 col-md-12 col-lg-7 col-xl-7 col-sm-12 mx-auto">
                <div class="form-group">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                    <span class="input-group-text color-input-fixed-icon">
                      <span class="fa-solid fa-user"></span>
                    </span>
                    </div>
                    <input type="text"
                      v-model="form.email"
                      class="form-control color-input-fixed-text"
                      placeholder="CORREO ELECTRÓNICO"
                      aria-label="Email"
                      :class="{ 'is-danger': errors.email }"
                    >
                  </div>
                  <span
                    v-if="errors.email"
                    class="text-danger float-left small error-danger"
                    >{{ errors.email }}</span
                  >
                </div>
                <div class="form-group">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                    <span class="input-group-text color-input-fixed-icon">
                      <span class="fa-solid fa-lock"></span>
                    </span>
                    </div>
                    <input
                      v-model="form.pass"
                      type="password"
                      ref="password"
                      class="form-control color-input-fixed-text"
                      placeholder="CONTRASEÑA"
                      aria-label="Password"
                      :class="{ 'is-danger': errors.pass }"
                      @keyup.enter="login()"
                    >
                    <div @click="showPass()" class="eye_pass">
                      <span id="pass" class="fa-regular fa-eye-slash"></span>
                    </div>
                  </div>
                  <span
                    v-if="errors.pass"
                    class="text-danger float-left small error-danger"
                    >{{ errors.pass }}</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-12 col-lg-7 col-xl-7 col-sm-12 mx-auto">
                <a
                  class="reset-password"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  >¿Olvidaste la contraseña?</a
                >
              </div>
              <div
                class="col-12 col-md-12 col-lg-7 col-xl-7 col-sm-12 mx-auto "
              >
                <button
                  @keyup.enter="login()"
                  :disabled="disableLoading"
                  type="button"
                  @click="login()"
                  class="btn btn-danger btn-md btn-block button-register"
                >
                  <span
                    v-if="disableLoading"
                    class="spinner-border spinner-border-md"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <template v-else>
                    <strong>ENTRAR</strong>
                  </template>
                </button>
              </div>

              <!-- Redes -->
              <div
                class="col-12 col-md-12 col-lg-9 col-xl-9 col-sm-12 mx-auto mt-4"
              >
                <p class="p-text1" style="text-align: center; font-size: 15px">
                  <strong>También inicia sesión con Google</strong>
                </p>

                <div class="row">
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12 mx-auto">
                    <button
                      :disabled="disableLoadingGoogle"
                      type="button"
                      @click="google()"
                      class="btn btn-light btn-sm btn-block btn-register"
                      id="btn-register-id"
                    >
                      <span
                        v-if="disableLoadingGoogle"
                        class="spinner-border spinner-border-md"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <template v-else>
                        <img alt="Google" src="@/assets/icon/google-24px.png" />
                        <!-- <i> Google </i> -->
                      </template>
                    </button>
                  </div>

                  <!-- <div
                    class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12 mx-auto pcb-c"
                  >
                    <button
                      :disabled="disableLoading"
                      type="button"
                      @click="facebook()"
                      class="btn btn-sm btn-block btn-register"
                      style="background-color: #4267b2; color: #fff"
                      id="btn-register-id"
                    >
                      <span
                        v-if="disableLoading"
                        class="spinner-border spinner-border-md"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <template v-else>
                        <img src="@/assets/icon/facebook-24px.png" />
                        <i class="pt-5"> Facebook </i>
                      </template>
                    </button>
                  </div> -->
                </div>
              </div>
              <!-- Fin redes -->

            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Modal de recuperar contraseña -->
    <div
      class="modal fade "
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              style="color: #6c757d"
            >
              Recuperar contraseña
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="input-group mb-3">
                <span class="fa fa-envelope-o icon iconreset"></span>
                <input
                  :class="{ 'is-danger': errorsEmail }"
                  v-model="email"
                  type="text"
                  class="form-control input-reset"
                  aria-label="email"
                  placeholder="Email *"
                  aria-describedby="basic-addon1"
                />
              </div>
              <span
                v-if="errorsEmail"
                class="text-danger float-left small error-danger"
                >{{ errorsEmail }}</span
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              @click="resetPassword()"
              type="button"
              class="btn btn-danger btn-sm"
            >
              <span
                v-if="disableLoadingSend"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <template v-else>Enviar</template>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para escoger logueo -->
    <div
      class="modal fade"
      id="exampleModalRedirect"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div style="padding:10px 20px 10px 20px" class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              style="color:#6c757d; margin:auto;"
            >
              Escoge tu tipo de usuario para loguearte
            </h5>
          </div>
          <div style="margin:auto;" class="modal-footer">
            <button
              @click="IrMotero()"
              type="button"
              class="btn btn-danger btn-sm"
            >
            Soy Motero
            </button>
            <button
              @click="IrLubricador()"
              type="button"
              class="btn btn-danger btn-sm"
            >
            Soy Lubricador
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para ir a las redes sociales de HavolineColombia -->
    <div
      class="modal fade"
      id="modalRRSS"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div style="min-width:45%;" class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modalRRSS" alt="fondo modal redes">
          <div class="content_btn_close">
            <img
              src="../../assets/iconsRRSS/logo_close.png"
              style="width:20px; height:auto;"
              title="cerrar popup"
              alt="cerrar popup"
              @click="closedModal()"
            />
          </div>
          <div style="margin-top:20px;" class="mr-md-4">
            <img
              src="../../assets/iconsRRSS/logo_havoline.png"
              style="width:150px; height:auto;"
              title="logo havoline"
              alt="logo havoline"
            />
          </div>
          <div class="modal_content_rrss">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              style="color:#6c757d; margin:auto;"
            >
              <span class="text_white">Síguenos en nuestras redes </span><span class="text_yellow">para que no <br> te pierdas de todo nuestro contenido.</span>
            </h5>
          </div>
          <div style="margin:auto;" class="modal_footer_rrs">
            <div class="row pt-4 pb-3 d-flex justify-content-center">
              <div class="">
                <a href="https://www.instagram.com/havolinecolombia" target="_blank" rel="noopener noreferrer">
                  <img 
                    height="40" 
                    width="40" 
                    src="../../assets/iconsRRSS/logo_instagram.png"
                    title="Instagram HavolineColombia"
                    alt="Instagram HavolineColombia"
                  />
                </a>
                <a href="https://www.facebook.com/HavolineColombia/" target="_blank" rel="noopener noreferrer"> 
                  <img
                    style="margin-left:15px"
                    height="40"
                    width="40"
                    src="../../assets/iconsRRSS/logo_facebook.png"
                    title="Facebook HavolineColombia"
                    alt="Facebook HavolineColombia"
                  />
                </a>
                <a href="https://www.youtube.com/ChevronColombia/" target="_blank" rel="noopener noreferrer"> 
                  <img
                    style="margin-left:15px"
                    height="40"
                    width="40"
                    src="../../assets/iconsRRSS/logo_youtube.png"
                    title="YouTube HavolineColombia"
                    alt="YouTube HavolineColombia"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { login } from "../../config/auth";
import { ROL } from "../../config/utils";
import { ORIGIN } from "../../config/utils";
import axios from "axios";
import $ from "jquery";

export default {
  name: "contentLanding",
  data() {
    return {
      results: [],
      disableLoading: false,
      disableLoadingGoogle: false,
      disableLoadingSend: false,
      email: "",
      errorsEmail: false,
      errors: {
        email: false,
        pass: false,
      },
      sizeName: null,
      sizes: [],
      banners: [],
      form: {
        email: "",
        pass: "",
      },
      section: this.$route.params.section,
      bannerList: [
        {
          id: 1,
          url: "/img/banner_2.1d8c10e5.jpg",
          description: "Bienvenido este es el primer Banner de prueba",
          status_id: 1,
          alt: "Bienvenido a Havoline MotoClub"
        },
        {
          id: 2,
          url: "/img/banner_2.1d8c10e5.jpg",
          description: "bien",
          status_id: 1,
        },
      ],
      isButtonWhatsappActivate: false,
      linksAll: [],
      link: null,
      showCarousel: false,
      showLogin: false,
    };
  },
  watch: {
    "form.email": function(n) {
      if (!n) {
        this.errors.email = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errors.email = "El email es inválido.";
      } else {
        this.errors.email = false;
      }
    },
    "form.pass": function(n) {
      if (n) {
        this.errors.pass = false;
      } else {
        this.errors.pass = "La contraseña es requerida.";
      }
    },
    email: function(n) {
      if (!n) {
        this.errorsEmail = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errorsEmail = "El email es inválido.";
      } else {
        this.errorsEmail = false;
      }
    },
  },
  methods: {
    google() {
      this.$gapi.login().then(({ currentUser }) => {
        // console.log('currentUser: ', JSON.stringify(currentUser));
        var profileUser = currentUser.getBasicProfile();
        var profileU = Object.values(profileUser);
        // console.log('profileU: ', profileU);
        let id_token = currentUser.getAuthResponse().id_token;
        this.data = {
          name: profileU[2],
          last_name: profileU[3],
          email: profileU[5],
          token: id_token
        };
        this.disableLoadingGoogle = true;
        axios
          .post("api/login/google", this.data)
          .then(async res => {
            if (res.data.cod == 0) {
              login(res.data.data.access_token);
              var data1 = {
                email: res.data.data.email,
                validatePass: res.data.data.ch_pw,
                gender: res.data.data.gender_id
              };
              sessionStorage.setItem("infoUser", JSON.stringify(data1));
              let encodeUserRole = btoa("userRole");
              let encodeValueUserRole = btoa(res.data.data.roleId);
              sessionStorage.setItem(encodeUserRole, encodeValueUserRole);
              if(res.data.data.codResponse == 0){
                this.$router.push({ name: "registerGoogle" });
              } else {
                var flagData = await localStorage.getItem('flagUpdateData');
                if(flagData > 0){
                  this.$router.push({ name: "updateDataUser" });
                } else {
                  if (this.$route.params.option == "digitales") {
                    this.$router.push({ name: "catalogueEcommerce" });
                  } else {
                    this.redirection(res.data.data.roleId);
                  }
                }
              }
            }
            this.disableLoadingGoogle = false;
          })
          .catch(error => {
            this.$swal({
              icon: "info",
              title: "Oops...",
              text: error.response.data.message,
              confirmButtonText: 'OK',
              confirmButtonColor: "#dc3545",
            });
            this.disableLoadingGoogle = false;
          });
      });
    },
    facebook() {
      var app = this;
      window.FB.login(
        (response) => {
          // console.log("fb response", response);
          if (response.status === "connected") {
            // console.log("Conexión exitosa");
            window.FB.api("/me", { fields: "last_name, name, email" }, function(
              resApi
            ) {
              // console.log(JSON.stringify(resApi));
              var data = {
                name: resApi.name,
                lastName: resApi.last_name,
                email: resApi.email,
                token: response.authResponse.accessToken,
              };
              axios
                .post("api/login/facebook", data)
                .then(() => {
                  // if (resB.data.cod == 0) {
                  // }
                })
                .catch((error) => {
                  app.$swal({
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                  });
                });
            });
          } else if (response.status === "not_authorized") {
            app.$swal({
              icon: "error",
              title: "Oops...",
              text: "No fue autorizado por Facebook para realizar esta acción",
            });
            // console.log("No fue autorizado por fdacebook");
          } else {
            // console.log("Error al conectarse con facebook");
            app.$swal({
              icon: "error",
              title: "Oops...",
              text: "No fue autorizado por Facebook para realizar esta acción",
            });
          }
        },
        { scope: "public_profile,email" }
      );
    },
    irRedirection(url) {
      if(url != null && url != 'null' && url != '') {
        var a = document.createElement('a');
        a.target="_blank";
        a.href=url;
        a.click();
      }
    },
    url(data) {
      var data1 = { "background-image": `url(${data})` };
      return data1;
    },
    textLa(data) {
      var data1 = { "text-align": `${data}` };
      // console.log(data1);
      return data1;
    },
    codes() {
      this.$router.push({ name: "registerCodes" });
    },
    loginLubricator() {
      this.$router.push({ name: "loginLubricator" });
    },
    more() {
      this.$router.push({ name: "club" });
    },
    motorBike() {
      this.$router.push({ name: "catalogue" });
    },
    digital() {
      this.$router.push({ name: "catalogueEcommerce1" });
    },
    login() {
      this.disableLoading = true;
      var app = this;
      if (this.validateForm()) {
        this.form.origin = ORIGIN.USER;
        axios
          .post("api/login", this.form)
          .then(async function(res) {
            if (
              res.data.access_token != "" &&
              res.data.access_token != undefined
            ) {
              login(res.data.access_token);
              var data = {
                email: app.form.email,
                validatePass: res.data.ch_pw,
                gender: res.data.gender_id,
              };
              sessionStorage.setItem("infoUser", JSON.stringify(data));
              let encodeUserRole = btoa("userRole");
              let encodeValueUserRole = btoa(res.data.roleId);
              sessionStorage.setItem(encodeUserRole, encodeValueUserRole);
              var flagData = await localStorage.getItem('flagUpdateData')
              if(flagData > 0){
                app.$router.push({ name: "updateDataUser" });
              } else {
                app.redirection(res.data.roleId);
                // app.$router.push({name: "profileUser"});
              }
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: "Hubo un error, intente en un momento o contáctese con el administrador",
              });
            }
            app.disableLoading = false;
          })
          .catch(function(err) {
            if (err.response.data.code){
              app.$swal({
                confirmButtonColor: "#dc3545",
                confirmButtonText: 'Ir',
                icon: "error",
                title: "Ingreso fallido",
                text: err.response.data.messages
              }).then(() => {
                  location.href = "/login/lubricador";
                }
              );
              app.disableLoading = false;
              this.$router.push({name: "loginLubricator"});
            }
            else{
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: "Credenciales incorrectas"
              });
              app.disableLoading = false;
            }
          });
      }
    },
    redirection(rolId) {
      switch (rolId) {
        case ROL.COMMERCIALROLE:
          this.$router.push({ name: "comercialProfile" });
          break;
        case ROL.LUBRICATORROLE:
          this.$router.push({ name: "lubricatorProfile" });
          break;
        case ROL.COLJUEGOS:
          this.$router.push({ name: "coljuegosProfile" });
          break;
        default:
          this.$router.push({ name: "profileUser" });
          break;
      }
    },
    resetPassword() {
      var app = this;
      this.disableLoadingSend = true;
      var data = {
        email: this.email,
      };
      if (this.validateReset()) {
        axios
          .post("api/password/create", data)
          .then(function(res) {
            if (res.data.ResponseCode == 0) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.ResponseMessage,
              });
            } else if (res.data.ResponseCode == 1) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
              });
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: "Error al recuperar contraseña",
              });
            }
            app.disableLoadingSend = false;
          })
          .catch(function(error) {
            console.log(error);
            app.disableLoadingSend = false;
          });
      }
    },
    irRegistrar() {
      this.$router.push({ name: "registerUser" });
    },
    validateForm() {
      if (!this.form.email) {
        this.errors.email = "El email es requerido.";
        this.disableLoading = false;
        return false;
      }
      if (!this.form.pass) {
        this.errors.pass = "La contraseña es requerida.";
        this.disableLoading = false;
        return false;
      }
      if (
        !this.errors.email &&
        !this.errors.pass &&
        !this.validEmail(this.errors.email)
      ) {
        return true;
      }
      this.disableLoading = false;
      return false;
    },
    validateReset() {
      if (!this.email) {
        this.errorsEmail = "El email es requerido.";
      }
      if (!this.errorsEmail && !this.validEmail(this.errorsEmail)) {
        return true;
      }
      this.disableLoading = false;
      return false;
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    getImagesSizes() {
      axios
        .get("api/file/get/banners/0")
        .then(res => {
          this.sizes = res.data.data;
          this.dimentionImage();
          // console.log(JSON.stringify(this.banners));
        })
        .catch(error => {
          console.log(error);
        });
    },
    dimentionImage(){
      const ancho = window.innerWidth;
      this.sizes.forEach(element => {
        // console.log(ancho);
        if(ancho <= 480 && element.id == 7){
          this.banners = [];
          this.banners.push(element);
          // console.log('this.banners sm ', JSON.stringify(this.banners));
        }
        else if((ancho > 480 && ancho <= 780) && element.id == 6){
          this.banners = [];
          this.banners.push(element);
          // console.log('this.banners md ', JSON.stringify(this.banners));
        }
        else if(ancho > 780 && element.id == 5){
          this.banners = [];
          this.banners.push(element);
          // console.log('this.banners lg ', JSON.stringify(this.banners));
        }
      });
      // console.log('this.image  ', JSON.stringify(this.image));
    },
    getImg() {
      axios
        .get("api/files/active/6")
        .then((res) => {
          if (res.data.cod == 0) {
            this.bannerList = res.data.data;
            // console.log(this.bannerList);
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    findSizeName(sizeId){
      this.sizeName = this.banners.find(name => name.id === sizeId);
      if (!this.sizeName)
        return "xs";
      else
        return this.sizeName.size;
    },
    previousSize(index){
      if (this.banners[index - 1])
        return "d-" + this.banners[index - 1].size + "-none";
      else
        return "";
    },
    isMinimumSize(index){
      if ((index + 1) == this.banners.length)
        return "";
      else
        return "d-none";
    },
    IrMotero(){
      $("#exampleModalRedirect").modal("hide");
      this.$router.push({ name: "login" });
    },
    IrLubricador(){
      $("#exampleModalRedirect").modal("hide");
      this.$router.push({ name: "loginLubricator" });
    },
    getLinks(){
      axios
      .get("api/get/links/all")
      .then((res) => {
        // console.log('res.data.data: ', JSON.stringify(res.data.data));
        if (res.data.cod == 0){
          this.linksAll = res.data.data;
          let temp = null;
          const currentUrl = window.location.href;
          const myArray = currentUrl.split("/");
          const linkWithoutQuery = myArray[3].split("?")[0];
          for (let i = 0; i < this.linksAll.length; i++) {
            const element = this.linksAll[i];
            if (element.status_id == 1 && linkWithoutQuery == element.link) {
              temp = element;
              break;
            }
          }
          if(temp != null){
            if(temp.link.includes("register")){
              // console.log('esto tiene temp ', JSON.stringify(temp));
              if(temp.link_destination == 1){
                localStorage.setItem('link', temp.link);
                localStorage.setItem('flagRegisterData', 1);
                localStorage.setItem('cantPoints', temp.cant_points);
                this.$router.push({ name: "landingRegister" });
              }
              else if(temp.link_destination == 2){
                localStorage.setItem('link', temp.link);
                localStorage.setItem('flagRegisterData', 1);
                localStorage.setItem('cantPoints', temp.cant_points);
                this.$router.push({ name: "landingQuickRegister" });
              } else {
                localStorage.setItem('link', temp.link);
                localStorage.setItem('flagRegisterData', 1);
                localStorage.setItem('cantPoints', temp.cant_points);
                this.$router.push({ name: "registerUser" });
              }
            }
            else if(temp.link.includes("update")){
              localStorage.setItem('link', temp.link);
              if(temp.type_user == 1){
                localStorage.setItem('flagUpdateData', 1);
                this.$router.push({ name: "login" });
              }
              else if(temp.type_user == 2){
                localStorage.setItem('flagUpdateData', 1);
                this.$router.push({ name: "loginLubricator" });
              }
              else {
                localStorage.setItem('flagUpdateData', 1);
                $("#exampleModalRedirect").modal("show");
              }
            }
          } else {
            localStorage.setItem('link', null);
            localStorage.setItem('flagRegisterData', 0);
            localStorage.setItem('cantPoints', 0);
            localStorage.setItem('flagUpdateData', 0);
          }
        }
        this.getFlags();
      })
      .catch((error) => {
        this.loading.changeDoc = false;
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
    },
    closedModal(){
      $("#modalRRSS").modal("hide");
    },
    getFlags(){
      if(localStorage.getItem('flagUpdateData') == 0 && localStorage.getItem('flagRegisterData') == 0){
        if (!sessionStorage.getItem('modalRRSS1')){
          $("#modalRRSS").modal("show");
          sessionStorage.setItem('modalRRSS1', 1);
        }
      }
    },
    showPass(){
      let pass = this.$refs.password;
      if(pass.type == "password"){
        pass.type = "text";
        $('#pass').addClass('fa-eye');
        $('#pass').removeClass('fa-eye-slash');
      } else {
        pass.type = "password";
        $('#pass').addClass('fa-eye-slash');
        $('#pass').removeClass('fa-eye');
      }
    },
  },
  async mounted(){
    await this.getLinks();
    this.getImg();
    this.getImagesSizes();
    localStorage.removeItem("productId");
    setTimeout(() => {
      this.showCarousel = true;
    }, 0);
    setTimeout(() => {
      this.showLogin = true;
    }, 3000);

    this.dimentionImage();
    window.addEventListener('resize', this.dimentionImage);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.dimentionImage);
  },
};
</script>

<style scope>
.modalRRSS{
  background-image: url('../../assets/iconsRRSS/fondo_modalrrss.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.modal_content_rrss, .modal_footer_rrs{
  padding: 20px 15px 30px 15px;
}
.content_btn_close{
  margin: 20px 25px auto auto;
  cursor: pointer;
}
.text_white{
  color: white;
  font-weight: bold;
}
.text_yellow{
  color: #ffce00;
  font-weight: bold;
}
.carousel-control-next,
.carousel-control-prev {
  width: 4%;
}
.title-home-banner{
  padding: 100px 10px 10px 100px;
  width: 70%;
  text-align: left !important;
}
.dinamic-banner{
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: white;
  height: 94vh;
  cursor: pointer;
  margin-top: -20px;
}
.banner-slider {
  padding-left: 5%;
  padding-top: 10%;
}
.title-home-banner {
  font-size: 66px;
  font-family: "Gotham-UltraItalic", sans-serif;
}
.importante {
  font-size: 70px;
  font-family: "Gotham-UltraItalic", sans-serif;
}
.card-info-home{
  background-color: transparent !important;
  border: none !important;
}
.card-header{
  background-color: transparent;
  border: none !important;
}
.movemos {
  font-size: 30px;
  font-family: "Gotham-UltraItalic", sans-serif;
  color: white !important;
  text-decoration: none !important;
}
.fa-caret-down{
  font-size: 30px;
  color: #dc3545;
}
.diferentes {
  font-family: "GothamBookItalic", sans-serif;
  text-align: left;
  font-size: 33px;
}
.subtitle-home-banner {
  font-family: "GothamBookItalic", sans-serif;
  font-size: 25px;
  text-align: left !important;
  padding: 10px 100px 10px 100px;
  max-width: 70%;
}
.button_1, .button_2{
  float: left;
  font-size: 18px;
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
}
.button_1{
  margin: 10px 10px 10px 100px;
}
.button_2{
  margin: 10px 10px 10px 10px;
}
.padding-content1 {
  padding-top: 20%;
}
.pcb-c {
  padding-bottom: 15%;
}
.pblr {
  padding-left: 3rem;
  padding-right: 3rem;
}
.p-text1 {
  font-family: "GothamBookItalic", sans-serif;
  text-align: justify;
}
.p-text2 {
  font-family: "GothamBoldItalic", sans-serif;
  text-align: left;
}
.cubrirte {
  font-size: 37px;
  font-family: "GothamBoldItalic", sans-serif;
}
.modal-title {
  color: #545252 !important;
}
a.reset-password {
  cursor: pointer !important;
  color: white;
  border-bottom: 1px solid;
}
a.reset-password:hover {
  color: #b3b3b3 !important;
  border-bottom: 1px solid;
}
.pbcontent {
  padding-bottom: 15%;
}
.content-home-class1 {
  height: 100%;
}
.content-home-class2 {
  height: 100%;
}
#content-home1 {
  background-size: cover;
  background-image: url("./../../assets/img/02.webp");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
#content-home {
  background-size: cover;
  background-image: url("./../../assets/img/IMAGEN_1.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}
.color-input-fixed-text{
  background-color: #ffffff00 !important;
  color: #fff !important;
  height: 30px !important;
  font-size: 13px;
}
.color-input-fixed-icon{
  background-color: #ffffff00 !important;
  color: white;
  height: 30px !important;
}
.color-input-fixed-text::placeholder {
  color: white !important;
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.input-reset {
  background-color: #ffffff00 !important;
  border-radius: 10px !important;
  border-color: #545252 !important;
  height: 30px !important;
  color: #545252 !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.input-reset::placeholder {
  color: #545252 !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.error-danger {
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-input-fixed-text{
  background-color: #ffffff00 !important;
  color: #fff !important;
  height: 30px !important;
  font-size: 13px;
}
.color-input-fixed-icon{
  background-color: #ffffff00 !important;
  color: white;
  height: 30px !important;
}
.color-input-fixed-text::placeholder {
  color: white !important;
}
.icon::before {
  position: absolute;
  top: 20%;
  left: 5%;
}
.fa.iconreset {
  color: #545252;
}
.button-register {
  height: 45px !important;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
}

/* FLOTANTE */
.icon-what {
  width: 200px;
}
.btn-flotante-1 {
  position: fixed;
  top: 10%;
  right: -1%;
  z-index: 99;
  transition: all 300ms ease 0ms;
}
/* FIN FLOTANTE */

/* TABLET */
@media (max-width: 1023px) {
  .btn-flotante-1 {
    top: 13%;
    right: -2%;
  }
  .diferentes {
    font-size: 36px;
  }
  .padding-content1 {
    padding-top: 30%;
  }
  .cubrirte {
    font-size: 32px;
  }
  .importante {
    font-size: 64px;
  }
}

@media (max-width: 1150px) and (min-width: 980px) {
  .title-home-banner {
    padding: 100px 10px 10px 100px !important;
    font-size: 55px !important;
    text-align: left !important;
    width: 80% !important;
  }
}

/* TABLET */
@media (max-width: 980px) and (min-width: 780px) {
  .title-home-banner {
    padding: 150px 10px 10px 100px !important;
    font-size: 40px !important;
    text-align: left !important;
    width: 100% !important;
  }
  .subtitle-home-banner {
    padding: 20px 10px 10px 100px !important;
    font-size: 22px !important;
    text-align: left !important;
    min-width: 90% !important;
  }
  .buttons_banners{
    padding-left: 100px;
  }
  .button_1, .button_2{
    font-size: 15px !important;
    float: left !important;
  }
  .button_1{
    margin: 10px 10px 10px 10px;
  }
  .button_2{
    margin: 10px 10px 10px 10px;
  }
}

/* TABLET */
@media (max-width: 780px) {
  .btn-flotante-1 {
    top: 30% !important;
    right: -3%;
  }
  .icon-what {
    width: 150px;
  }
  .title-home-banner {
    padding: 150px 10px 10px 10px !important;
    font-size: 35px !important;
    text-align: center !important;
    width: 100% !important;
  }
  .subtitle-home-banner {
    padding: 20px 10px 10px 10px !important;
    min-width: 90%;
    font-size: 20px !important;
    text-align: center !important;
    margin: auto;
  }
  .buttons_banners{
    display: flex;
    justify-content: center;
  }
  .button_1, .button_2{
    display: block !important;
    font-size: 15px !important;
    margin: 10px;
  }
  .diferentes {
    font-size: 20px;
    text-align: center;
  }
  .padding-content1 {
    padding-top: 65%;
  }
  .padding-content2 {
    padding-top: 25% !important;
  }
  .padding-content3 {
    padding-top: 15% !important;
  }
  .pblr {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .pcb-c {
    padding-bottom: 30%;
  }
  .movemos {
    font-size: 20px;
    color: white !important;
  }
  .p-text1-c {
    text-align: justify;
  }
  .cubrirte {
    font-size: 15px;
  }
  .importante {
    font-size: 30px;
  }
  .reset-password {
    margin-bottom: 10px;
  }
  .content {
    height: 100% !important;
  }
  #content-home {
    background-size: cover;
    background-image: url("./../../assets/img/IMAGEN_1.jpg");
    background-position: center center;
    background-attachment: fixed;
    background-color: "#171717";
  }
  img.logo-login-mobile {
    content: url("../../assets/logo-login.png");
  }
  .cont2 {
    padding-top: 15.5rem !important;
  }
  .icon-promo {
    width: 40px;
    height: 40px;
  }
  .text-promo {
    font-size: 11px;
  }
  #content3 {
    height: 100% !important;
  }
  .buttons{
    display: block !important;
  }
}

/* MOBILE M */
@media (max-width: 375px) {
  .btn-flotante-1 {
    top: 30% !important;
    right: -3%;
  }
  .buttons{
    display: block !important;
  }
  .icon-what {
    width: 150px;
  }
}

/* MOBILE S */
@media (max-width: 320px) {
  .btn-flotante-1 {
    top: 30% !important;
    right: -3%;
  }
  .icon-what {
    width: 150px;
  }
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}

@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>
